import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const prepaidTransactionSearchStyle = {
	...customSelectStyle
};

export default prepaidTransactionSearchStyle;
